import { CONSTANTS } from '@/constants/constants';

export const menuData = [
	{
		name: 'links_termsOfUse',
		href: '/terms-of-use',
		testId: 'terms-btn',
	},
	{
		name: 'links_privacyPolicy',
		href: '/privacy-policy',
		testId: 'privacy-btn',
	},
	{
		name: 'links_subscriptionTerms',
		href: '/subscription-terms',
		testId: 'subscr-terms-btn',
	},
	{
		name: 'links_dontSellMyPersonalInfo',
		href: `/dont-sell-my-personal-info`,
		testId: 'dont-sell-my-personal-info-btn',
	},
	{
		name: 'links_contactSupport',
		href: CONSTANTS.SUPPORT_URL,
		target: '_blank',
		testId: 'support-btn',
	},
	{
		name: 'links_cookiePolicy',
		href: '/cookie-policy',
		testId: 'cookie-policy-btn',
	},
];
